import { INDIVIDUAL } from './_http';
// import { queryString } from '../../helpers';

const getDistributionHistory = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/GetDistributionHistory`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getLastRecommendedDistribution = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/GetLastRecommendedDistribution`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const completeDistribution = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/CompleteDistribution`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const profiencyQuestions = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/ProfiencyQuestions`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const saveProfiencyAnswer = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Robo/SaveProfiencyAnswer`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const rgpQuestions = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Robo/RgpQuestions`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getDistributionHistory, getLastRecommendedDistribution, completeDistribution, profiencyQuestions, saveProfiencyAnswer, rgpQuestions }